import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@univdiam/ui/components/button";
import { CollectionDataTable } from "@univdiam/ui/customComponents/CollectionList/data-table";
import { groupColumns } from "@univdiam/ui/customComponents/CollectionList/columns";
import { EditCollectionForm } from "@univdiam/ui/customComponents/CollectionList/EditCollectionForm";

import api from "@/http/api";

export default function CollectionPage() {
  const [data, setData] = useState([]);
  const [editCollectionData, setEditCollectionData] = useState(null);

  useEffect(() => {
    api
      .get("/api/collection")
      .then((res) => {
        const transformed = res.data.data.map((collection: any) => ({
          collection_id: collection.collection_id.toString(),
          name: collection.name,
          code: collection.code,
          status: collection.status === 1 ? "Enabled" : "Disabled",
        }));
        setData(transformed);
      })
      .catch((err) => console.error("Failed to fetch Collection", err));
  }, []);

  const handleDelete = async (id: string) => {
    console.log(id);
    const confirm = window.confirm(
      "Are you sure you want to delete this Collection?"
    );
    if (!confirm) return;

    try {
      const res = await api.delete(`/api/collection/${id}`);
      if (res.status === 200) {
        alert("Collection deleted successfully.");
        // setData(prev => prev.filter(group => group.group_id !== id))
      } else {
        alert("Failed to delete Collection.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Something went wrong.");
    }
  };

  const handleEdit = async (id: string) => {
    try {
      const res = await api.get(`/api/collection/${id}`);
      if (res.status === 200) {
        setEditCollectionData(res.data);
        // setData(prev => prev.filter(group => group.group_id !== id))
      } else {
        alert("Failed to fetch Collection.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Something went wrong.");
    }
  };

  const navigate = useNavigate();

  const handleAddGroup = () => {
    navigate("/Collection/add");
  };

  const columns = groupColumns({ onEdit: handleEdit, onDelete: handleDelete });

  return (
    <div className="p-5">
      <div className="flex justify-between mb-4">
        <h1 className="text-xl font-semibold">Collection Management</h1>
        {/* <Button onClick={() => setCreateGroup(true)}>+ Add Group</Button> */}
        <div className="flex justify-end mb-4">
          <Button onClick={handleAddGroup}>+ Add Collection</Button>
        </div>
      </div>
      <CollectionDataTable columns={columns} data={data} />
      {editCollectionData && (
        <EditCollectionForm
          group={editCollectionData}
          onCancel={() => setEditCollectionData(null)}
          onSave={() => {
            setEditCollectionData(null);
            fetchCollection(); // refresh table
          }}
        />
      )}
    </div>
  );
}
